import { render, staticRenderFns } from "./ccm-study-plan-clinic-apply.vue?vue&type=template&id=b825191c&"
import script from "./ccm-study-plan-clinic-apply.vue?vue&type=script&lang=js&"
export * from "./ccm-study-plan-clinic-apply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports